import React from 'react';
import { Landmark } from 'lucide-react';

const VillageHistory = () => {
  // Placeholder content
  const history = {
    title: "The Ancient Roots of Our Village",
    paragraphs: [
      "Our village, nestled by the serene river, has a history stretching back over a thousand years. Archaeological findings suggest that the first settlements date back to the early Chola dynasty.",
      "The village was a significant center for trade and agriculture, known for its fertile lands and skilled artisans. The grand temple, built in the 12th century, stands as a testament to the village's prosperous past.",
      "Folklore speaks of a wise and just leader who established a system of governance that prioritized community welfare, a tradition that residents proudly uphold to this day.",
      "Through the centuries, the village has witnessed the rise and fall of empires, yet it has retained its unique cultural identity and resilient spirit."
    ],
    images: [
      '/placeholder-image.png',
      '/placeholder-image.png',
      '/placeholder-image.png',
    ]
  };

  return (
    <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8 bg-white rounded-lg shadow-md">
      <div className="text-center mb-12">
        <Landmark className="mx-auto h-12 w-12 text-blue-600" />
        <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">Our Village's Story</h1>
        <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">A journey through time, uncovering the legacy of our ancestors.</p>
      </div>

      <div className="prose prose-lg lg:prose-xl mx-auto text-gray-600">
        <h2>{history.title}</h2>
        {history.paragraphs.map((p, index) => (
          <p key={index}>{p}</p>
        ))}
      </div>

      <div className="mt-12">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-6">Glimpses of the Past</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {history.images.map((src, index) => (
                  <div key={index} className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                      <img src={src} alt={`Historic view ${index + 1}`} className="w-full h-64 object-cover" />
                  </div>
              ))}
          </div>
      </div>
    </div>
  );
}

export default VillageHistory;
